/* ===================================================
 * app.js v1.0
 * ===================================================
 */
 $(document).on('lazyloaded', function(e) {
     console.log('** lazyloaded is fired', e.target);  
     // console.log('** lazyloaded is fired');  
 })

 $(document).on('lazybeforeunveil', function(e) {
     
     console.log('lazyloader', e.target);

     var viewportWidth = $(window).innerWidth();
     // var bg = $(e.target).data('bg-mobile');
     var bg = $(e.target).data('bg-mobile');
     if (viewportWidth > 0) {
         bg = $(e.target).data('bg-mobile');
     }
     if (viewportWidth > 768) {
         bg = $(e.target).data('bg-tablet');
     }
     if (viewportWidth > 1023) {
         bg = $(e.target).data('bg-desktop');
     }
     if (viewportWidth > 1800) {
         bg = $(e.target).data('bg-super');
     } 

     if (bg) {
       // $(e.target).css('background-image', 'url(' + bg + ')');
       // TweenMax.set($($(e.target)), {backgroundImage:'url(' + bg + ')'});
       // Also if you're going to use the css wrapper it shoud be like this:
       // TweenMax.set($(e.target),   {opacity:0}); // delay: 1

       // var giveFadeInClass = function(){
         // $(e.target).addClass('fade-in');
       // }

       TweenMax.set($(e.target),   {css:{backgroundImage:'url(' + bg + ')'}, delay: 0.4}); // onComplete:giveFadeInClass

       // TweenMax.to($(e.target),    0.5,  {opacity:1, delay: 0.5}); // delay: 1
       
       // // in case of issues with opacity
       // var setOpacityTo1 = function(){
       //   console.log('%c setOpacityTo1 called', 'color: #bada55, background: #000');
       //   console.log($(e.target));
       //   TweenMax.set($(e.target),   {opacity:1});
       // }
       // TweenMax.delayedCall(6, setOpacityTo1);  

     }

 }); 


!function($) {

	$(function(){

		var $animation_is_on = true;

		// add is loaded to body
		$('body').addClass("js-is-loaded");

		var $window = $(window);
		
		// Init Cookie bar with default settings
		$.cookieBar();

		/*
		** Useful JS functions you're likely to need
		*/
		
		// Render any ACF Maps (if any)
		if ( $('.acf-map').length > 0) {
			$('.acf-map').each(function(){
				render_map( $(this));
			});
		}


		// Open every external link in a new window.
		// $("a:urlExternal").attr( "target", "_blank" );


		// Popup Gallery
		$('.woocommerce-product-gallery__image').magnificPopup({
			type: 'image',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: true,
			delegate: 'a',
			fixedContentPos: false,
			gallery: {
				enabled: true,
				preload: [0,1] 
			},
	    });

		/////////////////////////////////
		// A11y remove blue outlines.. //
		/////////////////////////////////

		// // Listen to tab events to enable outlines (accessibility improvement)
		// document.body.addEventListener('keyup', function(e) {
		//   if (e.which === 9) /* tab */ {
		//     document.documentElement.classList.remove('no-focus-outline');
		//   }
		// });

		function handleFirstTab(e) {
		    if (e.keyCode === 9) { // the "I am a keyboard user" key
		        document.body.classList.add('user-is-tabbing');
		        window.removeEventListener('keydown', handleFirstTab);
		    }
		}

		window.addEventListener('keydown', handleFirstTab);

		// $('.js-gallery_block-thumbnail').each(function() { // the containers for all your galleries
		//     $(this).magnificPopup({
		//          mainClass: 'mfp-fade',
		//          removalDelay: 500, //delay removal by X to allow out-animation
		//         delegate: 'a', // the selector for gallery item
		//         type: 'image',
		//         gallery: {
		//           enabled:true,
		//           preload: [0,2], // read about this option in next Lazy-loading section

		//           navigateByImgClick: true,

		//           arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

		//           tPrev: 'Previous (Left arrow key)', // title for left button
		//           tNext: 'Next (Right arrow key)', // title for right button
		//           tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
		          
		//         },
		//         image: {
		//           //titleSrc: 'title'
		//           titleSrc: 'data-title'
		//         }
		//     });
		// });




		// LAXXX p.lax scroll anims
		

		// lax.setup();
		  
		// document.addEventListener('scroll', function(x) {
		//   lax.update(window.scrollY);
		// }, false);

		// // let w = window.innerWidth;
		// // window.addEventListener("resize", function() {
		// //   if(w !== window.innerWidth) {
		// //     lax.populateElements();
		// //   }
		// // });

		// lax.update(window.scrollY);


		// SCROLL Animation.. SCROLLMAGIC..
		if ($animation_is_on) {


			console.log('we animating :)');

			// controller
			var controller = new ScrollMagic.Controller();

			// spin tween
			var $logoText	= $(".navbar #logo-copy-spin svg"),
				spin_tl 	= TweenMax.to( $logoText, 1, {rotation: 360, ease: Linear.easeNone}),
				h 			= $('body').outerHeight(),
				wh 			= window.innerHeight,
				ww 			= window.innerWidth;
				console.log('ww is', ww);

			// spinning scene
			var scene = new ScrollMagic.Scene({
				triggerElement: $("body")[0],
				duration: h
			}) // triggerElement: "body", duration: 400, offset: 250
			.setTween(spin_tl)
			// .setPin($logoText)
			// .addIndicators({name: "resize"}) // add indicators (requires plugin)
			.addTo(controller);


			////////////

			// body.home { .navbar-brand { top: 28vh; } }
			// body.single { .navbar-brand { top: 38vh; } }
			// body.archive { .navbar-brand { top: 39vh; } }


			// nav logo tween
			var $logo 		= $(".navbar-brand > div"),
				logo_tl 	= TweenMax.to( $logo, 1, {y: 0, scale: 1, ease: Linear.easeNone});
				// h 			= $('body').outerHeight(),
				// wh 			= window.innerHeight,
				// ww 			= window.innerWidth;
				// console.log('ww is', ww);

			// position logo according to page and viewport
			
			// $logoOffset = wh*0.14;
			$logoOffset = 0;

			// if( (ww >= 1024) ) 	{ $logoOffset = wh*0.24; }

			if ($('body').hasClass('home') ) {
				if( (ww < 768) ) 	{ $logoOffset = wh*0.16; }
				if( (ww >= 768) ) 	{ $logoOffset = wh*0.21; }
				if( (ww >= 1024) )	{ $logoOffset = wh*0.24; }
				if( (ww >= 1400) )	{ $logoOffset = wh*0.165; }
			};

			// if ($('body').hasClass('archive post-type-archive') ) {
			// 	if( (ww < 768) ) 	{ $logoOffset = '+=263px'; }
			// 	if( (ww >= 768) ) 	{ $logoOffset = '+=212px'; }
			// 	if( (ww >= 1024) ) 	{ $logoOffset = '+=190px'; }
			// };

			// if ($('body').hasClass('single') ) {
			// 	if( (ww < 768) ) 	{
			// 		$heroHeightIs 	= $('.hero').outerHeight();
			// 		$logoOffset 	= ($heroHeightIs - 40);
			// 	}
			// 	if( (ww >= 768) ) 	{ $logoOffset = '+=175px'; }
			// 	// if( (ww >= 1024) ) 	{ $logoOffset = '+=190px'; }
			// };

			// if ($('body').hasClass('author') ) {
			// 	if( (ww < 768) ) 	{
			// 		$heroHeightIs 	= $('.author__hero').outerHeight();
			// 		$logoOffset 	= ($heroHeightIs - 40);
			// 	}
			// 	if( (ww >= 768) ) 	{ $logoOffset = '+=160px'; }
			// 	// if( (ww >= 1024) ) 	{ $logoOffset = '+=190px'; }
			// };
			

			console.log('$logoOffset is', $logoOffset);
			if ( $('body').hasClass('home') && (ww >= 768) ) {
				TweenMax.set( $logo, { y: $logoOffset, scale: 2.5 });
			}

			// // homepage
			// // mob 
			// body.home { .navbar-brand { top: 16vh; } }
			// // tablet
			// body.home { .navbar-brand { top: 21vh; } }
			// // desktop
			// body.home { .navbar-brand { top: 24vh; } }

			// // archive-restaurants
			// // mob 
			// body.post-type-archive-restaurants { .navbar-brand { top: 263px; } }
			// // tablet
			// body.post-type-archive-restaurants { .navbar-brand { top: 212px; } }
			// // desktop
			// body.post-type-archive-restaurants { .navbar-brand { top: 28vh; } }






			// nav logo scene
			var scene = new ScrollMagic.Scene({
				// duration: h
				triggerElement: $("body")[0],
				duration: '30%',
				offset: wh*0.5
			}) // triggerElement: "body", duration: 400, offset: 250
			.setTween(logo_tl)
			// .setPin($logoText)
			// .addIndicators({name: "resize"}) // add indicators (requires plugin)
			.addTo(controller);



			// HOMEPAGE - HERO
			if ($('body').hasClass('home') ) { // && (ww =< '768')

				console.log('homepage');
				
				if( (ww >= 768) ) {


					// build tween
					var $hero_img 		= $('.js-home-hero--img'),
						$hero_break 	= $('.home-hero--intro--logo-breakfast'),
						$hero_london 	= $('.home-hero--intro--logo-london'),
						$hero_btn 		= $('.desktop-find-your-breakfast-btn'),
						$hero_title 	= $('.home-hero--title-dots-cta-wrapper'),
						$hero_intro 	= $('.js-home-hero--first-part-title'),
						$hero_tl 		= new TimelineMax();

					$hero_tl
						// .to($hero_img, 			1, {x: "-=100px", ease: Linear.easeNone, force3D:true }, 'go')
						// .to($hero_break, 		1, {x: "-=500px", ease: Linear.easeNone, force3D:true }, 'go')
						// .to($hero_london, 		1, {x: "+=100px", ease: Linear.easeNone, force3D:true }, 'go')
						.to($hero_break, 		1, {x: "-500%", ease: Linear.easeNone, force3D:true }, 'go')
						.to($hero_london, 		1, {x: "100%", ease: Linear.easeNone, force3D:true }, 'go')
						.to($hero_img, 			1, {y: "-100%", ease: Linear.easeNone, force3D:true }, 'go')
						.to($hero_btn, 			1, {y: -wh*0.2, ease: Linear.easeNone, force3D:true }, 'go')
						.to($hero_title, 		1, {y: -wh*0.3, ease: Linear.easeNone, force3D:true }, 'go')
						.to($hero_intro, 		1, {y: -wh*0.4, ease: Linear.easeNone, force3D:true }, 'go')
					;

					var scene = new ScrollMagic.Scene({
										// triggerElement: $(".site-content-wrapper"),
										triggerElement: $("body")[0],
										duration: '100%',
										offset: wh*0.5
									}) // triggerElement: "body", duration: 400, offset: 250
									.setTween($hero_tl)
									// .setPin($logoText)
									// .addIndicators({name: "resize"}) // add indicators (requires plugin)
									.addTo(controller);

				}

			}

			// PRODUCT PROMO...

			
			if ($('.js-product_promo').length ) { // && (ww =< '768')

				console.log('product promo...');

				if( (ww >= 768) ) {

					// build tween
					var $promo_img 			= $('.product-promo__thumbnail'),
						$promo_cta 			= $('.product-promo__cta'),
						$promo_content 		= $('.product-promo__content'),
						$promo_tl 			= new TimelineMax();

					$promo_tl
						.to($promo_content, 	1, {y: "-10%", ease: Linear.easeNone, force3D:true }, 'go')
						.to($promo_img, 		1, {y: "-50%", ease: Linear.easeNone, force3D:true }, 'go')
					;

					var scene = new ScrollMagic.Scene({
										// triggerElement: $(".site-content-wrapper"),
										triggerElement: $(".section--fc.product_promo"),
										duration: '110%',
										offset: '-110%'
									}) // triggerElement: "body", duration: 400, offset: 250
									.setTween($promo_tl)
									// .setPin($logoText)
									// .addIndicators({name: "resize"}) // add indicators (requires plugin)
									.addTo(controller);

				}

			}


			// FEATURED POST

			// section--fc featured_post

			if ($('.section--fc.featured_post').length ) { // && (ww =< '768')

				console.log('product promo...');

				if( (ww >= 768) ) {

					// build tween
					var $featPost_img 			= $('.section--fc.featured_post .post-featured-card__thumbnail'),
						$featPost_content 			= $('.section--fc.featured_post .post-featured-card__content'),
						$featPost_tl 			= new TimelineMax();

					$featPost_tl
						.to($featPost_content, 	1, {y: "-10%", ease: Linear.easeNone, force3D:true }, 'go')
						.to($featPost_img, 		1, {y: "10%", ease: Linear.easeNone, force3D:true }, 'go')
					;

					var scene = new ScrollMagic.Scene({
										// triggerElement: $(".site-content-wrapper"),
										triggerElement: $(".section--fc.featured_post"),
										duration: '110%',
										offset: '-110%'
									}) // triggerElement: "body", duration: 400, offset: 250
									.setTween($featPost_tl)
									// .setPin($logoText)
									// .addIndicators({name: "resize"}) // add indicators (requires plugin)
									.addTo(controller);

				}

			}


		}

			// $(function () { // wait for document ready
			// 	// init controller
			// 	var controller = new ScrollMagic.Controller();

			// 	// build tween
			// 	var tween = TweenMax.to("#animate", 0.5, {scale: 3, ease: Linear.easeNone});

			// 	// build scene
			// 	var scene = new ScrollMagic.Scene({triggerElement: "#multiDirect", duration: 400, offset: 250})
			// 					.setTween(tween)
			// 					.setPin("#animate")
			// 					.addIndicators({name: "resize"}) // add indicators (requires plugin)
			// 					.addTo(controller);

			// 	// // init controller horizontal
			// 	// var controller_h = new ScrollMagic.Controller({vertical: false});

			// 	// // build tween horizontal
			// 	// var tween_h = TweenMax.to("#animate", 0.5, {rotation: 360, ease: Linear.easeNone});

			// 	// // build scene
			// 	// var scene_h = new ScrollMagic.Scene({duration: 700})
			// 	// 				.setTween(tween_h)
			// 	// 				.setPin("#animate")
			// 	// 				.addIndicators({name: "rotate"}) // add indicators (requires plugin)
			// 	// 				.addTo(controller_h);
			// });


		// // init
		// var ctrl = new ScrollMagic.Controller({
		//     globalSceneOptions: {
		//         triggerHook: 'onLeave'
		//     }
		// });
		 
		// // Create scene
		// $("section").each(function() {
		   
		//     new ScrollMagic.Scene({
		//         triggerElement: this,
		//         duration: '50%'
		//     })
		//     .setPin(this)
		//     .addTo(ctrl);
		// });


	    // RESTAURANT FILTER TOGGLES
	    $('.restaurant-filters label').click(function(event) {
		  $(this).parent().toggleClass('is-toggled');
		});


		// $('.js-restaurant-filters').select2();

		
		
		if ( $(".restaurant-filters").length > 0) {
			$(".restaurant-filters select").each( function(){
				var $this = $(this);
				if ( $this.prop('multiple')) {
					$this.select2({
						placeholder: $this.data('placeholder'),
						templateResult: function (data) {    
						    // We only really care if there is an element to pull classes from
						    if (!data.element) {
						      return data.text;
						    }

						    var $element = $(data.element);

						    var $wrapper = $('<span></span>');
						    $wrapper.addClass($element[0].className);

						    $wrapper.text(data.text);

						    return $wrapper;
						  }
					});
				}
			});
		}


		$('.woocommerce-ordering select').select2();

		$('.woocommerce-ordering select').on('select2:opening select2:closing', function( event ) {
		    var $searchfield = $(this).parent().find('.select2-search__field');
		    $searchfield.prop('disabled', true);
		});




	    /// HOMEPAGE DESKTOP HERO ROLLOVER - 2 parts of title, second part highlights first:
	    // $(function() {
    	var $slidenum = null;
      	$('.home-hero--title-and-dots .home-hero--single-restaurant').hover(function() {
	      	$slidenum = $(this).data('slick-index');
	      	$('.home-hero--first-part-title .home-hero--single-restaurant[data-slick-index="'+$slidenum+'"] a').css('color', '#eda7c9');
	    }, function() {
	        // on mouseout, reset the background colour
	        $('.home-hero--first-part-title .home-hero--single-restaurant a').css('color', '');
	    });
	    // });



	    // Address change function
	    /*$.address.change(function(event) { 
			console.log( event);
		});  */

		// Show Search on Desktop
		$('.js-searchform-toggle').click(function(event) {
		  $('body').toggleClass('searchform-is-visible');
		});


		// TEMP - hamburger toggle effect - can't find it in Bootstrap
		$('.js-menu-toggle').click(function(event) {
			$('body').toggleClass('mob-nav-is-active');
		  	$(this).toggleClass('is-active');
		  	// $('.js-main-nav-wrapper').toggleClass('is-active');
		});


		// homepage hero sliders
		// js-home-hero--img
		// js-home-hero--title-and-dots
		if($('body.home')){
			// slick init
		    desktop_homepage_slider();

		 //    $('body').on('scroll', function() {
		 //    	if ($(this).scrollTop() <= 0) {
		 //    		alert('start reached');
		 //    	}
			// });
		}

	 //    $('body').on('scroll', function() {
	 //    	if ($(this).scrollTop() <= 0) {
	 //    		alert('start reached');
	 //    	}
		// });

		$(window).scroll(function() {
        	// console.log('logging');
        	if ($(this).scrollTop() <= 10) {
        		$('.js-home-hero--img').slick('slickPlay');
        		$('.js-home-hero--first-part-title').slick('slickPlay');
        		$('.js-home-hero--title-and-dots').slick('slickPlay');
        	} else {
        		$('.js-home-hero--img').slick('slickPause');
        		$('.js-home-hero--first-part-title').slick('slickPause');
        		$('.js-home-hero--title-and-dots').slick('slickPause');
        	}
      	});

		function desktop_homepage_slider(){

		    var img_title_settings = {

		        dots:               false,
		        arrows:             false,
		        // infinite: true,
		        speed:              750,
		        // slidesToShow: 4,
		        // slidesToScroll: 1,
		        autoplay:           true,
		        fade:               false,
		        // autoplaySpeed: 		2900,
		        vertical:           false,
		        verticalSwiping:    false,
		        touchMove:          false,
		        // touchThreshold: true,
		        swipe:              false,
		        touchThreshold:     10,
		        // draggable: true,
		        pauseOnHover:       false,
		        asNavFor: '.js-home-hero--title-and-dots, .js-home-hero--first-part-title',
		        useTransform: true,
   				cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
		        // rtl: true,
		    }

		    var first_part_title_settings = {

		        dots:               false,
		        arrows:             false,
		        // infinite: true,
		        speed:              750,
		        // slidesToShow: 4,
		        // slidesToScroll: 1,
		        autoplay:           true,
		        fade:               false,
		        // autoplaySpeed: 3900,
		        vertical:           true,
		        verticalSwiping:    false,
		        touchMove:          false,
		        // touchThreshold: true,
		        swipe:              false,
		        // touchThreshold:     10,
		        // draggable: true,
		        pauseOnHover:       false,
		        useTransform: true,
   				cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
		        // slidesToScroll: -1,
		        // asNavFor: '.js-home-hero--title-and-dots,.js-home-hero--img',
		        // rtl: true,
		    }

		    var title_dots_settings = {

		        dots:               true,
		        arrows:             false,
		        // infinite: true,
		        speed:              750,
		        // slidesToShow: 4,
		        // slidesToScroll: 1,
		        autoplay:           true,
		        fade:               false,
		        // autoplaySpeed: 3900,
		        vertical:           true,
		        verticalSwiping:    false,
		        touchMove:          false,
		        // touchThreshold: true,
		        swipe:              false,
		        touchThreshold:     10,
		        useTransform: true,
		        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
		        // draggable: true,
		        pauseOnHover:       false,
		        asNavFor: '.js-home-hero--img, .js-home-hero--first-part-title',
		        // rtl: true,
		    }

		    $('.js-home-hero--img').slick(img_title_settings);
		    $('.js-home-hero--first-part-title').slick(first_part_title_settings);
		    $('.js-home-hero--title-and-dots').slick(title_dots_settings);

		}

		$('.js-home-hero--img').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		  // console.log(nextSlide);
		  updateLazyImage();
		});


		///////////////////////////////
		// LAZY LOAD Sizes in RESIZE //
		///////////////////////////////

		window.addEventListener('resize', updateLazyImage);

		function updateLazyImage() {
		    // alert('imgs resize');
		    var viewportWidth = $(window).innerWidth();
		    $.each($(".lazyloaded"), function(index, item) {
		        var bg = $(item).data('bg-mobile');

		        if (viewportWidth > 0) {
		            bg = $(item).data('bg-mobile');
		        }
		        if (viewportWidth > 768) {
		            bg = $(item).data('bg-tablet');
		        }
		        if (viewportWidth > 1023) {
		            bg = $(item).data('bg-desktop');
		        }
		        if (viewportWidth > 1800) {
		            bg = $(item).data('bg-super');
		        }
		        // console.log('lazyloader resize viewport is', viewportWidth, ' - bg is ', bg);
		        if (bg) {
		            $(item).css('background-image', 'url(' + bg + ')');
		            // console.log('chaning bg to ', bg);
		        }
		    });
		}


		$('.js-home-hero--img').on('init', function(event, slick, currentSlide, nextSlide){
		  console.log('homepage slider init');
		  updateLazyImage();
		});


	}); // end doc ready










	/*
	** Google Map Functions for ACF
	*/
		// Render the map
		function render_map( $el ) {
		 
			// var
			var $markers = $el.find('.marker');
		 
			var zoomLevel = 15;

			var snazzyStyles = [
				  // attempt to remove indoor maps
				  // {"stylers": [ {"visibility": "off" } ] },
				  // {"featureType": "water","stylers": [{"visibility": "on"} ] },
				  // {"featureType": "poi","stylers": [ {"visibility": "on"} ]},
				  // {"featureType": "transit","stylers": [{ "visibility": "on"}] },
				  // { "featureType": "landscape","stylers": [ { "visibility": "on" } ] },
				  // { "featureType": "road", "stylers": [{ "visibility": "on" } ] },
				  // { "featureType": "administrative",  "stylers": [{ "visibility": "on" } ] },
				  // // { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ]}, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ]}, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ]}, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ]}, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ]}, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ]}, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ]}, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ]}, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ]}, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ]}, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ]}, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ]}, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ]}, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ]}
				  {"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"saturation":"26"},{"lightness":"33"},{"gamma":"2.63"},{"weight":"2.83"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"hue":"#00ffcf"},{"saturation":"26"},{"lightness":"-5"}]}

				];

			// vars
			var args = {
				zoom		: zoomLevel,
				// disableDefaultUI: true,
				zoomControl: true,
				scaleControl: true,
				// mapTypeControl: false,
				// streetViewControl: false,
				// rotateControl: false,
				fullscreenControl: false,
				
				center		: new google.maps.LatLng(0, 0),
				mapTypeId	: google.maps.MapTypeId.ROADMAP,
				scrollwheel : false,
				draggable	: false,
				// styles 		: snazzyStyles 
				// styles 		: [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"},{"lightness":33}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2e5d4"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#c5dac6"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":20}]},{"featureType":"road","elementType":"all","stylers":[{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#c5c6c6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#e4d7c6"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#fbfaf7"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#acbcc9"}]}]
				styles 		: [
				{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"saturation":"26"},{"lightness":"33"},{"gamma":"2.63"},{"weight":"2.83"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"hue":"#00ffcf"},{"saturation":"26"},{"lightness":"-5"}]}

			]
			};
		 
			// create map	        	
			var map = new google.maps.Map( $el[0], args);

			// map.addListener('tilesloaded', function () { 
			// 	console.log('map loaded');
			// 	$('body').addClass('map-is-loaded');
			// });
		 
			// add a markers reference
			map.markers = [];
		 
			// add markers
			$markers.each(function(){
		 
		    	add_marker( $(this), map );
		 
			});
		 
			// center map
			center_map( map );
		 
		}
		 
		// Add Markers
		// - <div class="marker" data-lat="#" data-lng="#"></div>
		function add_marker( $marker, map ) {
		 
			// var
			var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

			var markerIcon = {
			    url: wiaw_js_vars.themeurl + '/2x/inline-marker.png',
			    origin		: 	new google.maps.Point(0, 0),
			    anchor 		: 	new google.maps.Point(23, 32),
			    size 		: 	new google.maps.Size(47, 63),
			    scaledSize	: 	new google.maps.Size(47, 63)
			};

			// create marker
			var marker = new google.maps.Marker({
				position	: latlng,
				map			: map,
				icon		: markerIcon
			});
		 
			// add to array
			map.markers.push( marker );
		 
			// if marker contains HTML, add it to an infoWindow
			if( $marker.html() )
			{
				// create info window
				var infowindow = new google.maps.InfoWindow({
					content		: $marker.html()
				});
		 
				// show info window when marker is clicked
				google.maps.event.addListener(marker, 'click', function() {
		 
					infowindow.open( map, marker );
		 
				});
			}
		 
		}
		 
		// Center the map on a point, or bound to markers
		function center_map( map ) {
		 
			// vars
			var bounds = new google.maps.LatLngBounds();
		 
			// loop through all markers and create bounds
			$.each( map.markers, function( i, marker ){
		 
				var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
		 
				bounds.extend( latlng );
		 
			});
		 
			// only 1 marker?
			if( map.markers.length == 1 ) {
				// set center of map
			    map.setCenter( bounds.getCenter() );

			} else {

				// fit to bounds
				map.fitBounds( bounds );
			}
		 
		}



// [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"saturation":"26"},{"lightness":"33"},{"gamma":"2.63"},{"weight":"2.83"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"hue":"#00ffcf"},{"saturation":"26"},{"lightness":"-5"}]}]



}(window.jQuery);